<ng-template #modal role="document" let-modal>
  <div class="offcanvas-header border-bottom">
    <h4 class="modal-title">{{ "heading-title.export" | translate }}</h4>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="offcanvas-body">
    <div class="row">
      <div class="col-6">
        <p class="font-weight-semibold">{{ "label-title.available" | translate }}</p>
        <div class="export-left-column">
          <div class="search-box">
            <input
              type="text"
              id="export-available-item-search"
              name="searchTerm"
              class="form-control"
              placeholder="{{ 'label-title.search' | translate }}"
              style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; border-color: var(--vz-border-color); border-bottom: 0"
              [(ngModel)]="searchAvailableItem"
            />
            <i class="ri-search-line search-icon"></i>
          </div>
          <div class="export-items-box border">
            <div id="export-available-move-all" class="mb-0 px-2 py-1 c-pointer text-primary font-weight-semibold" (click)="onMoveAllClick(exportItemType.available)">
              {{ "button-title.move-all" | translate }} <i class="ri-arrow-right-s-line"></i>
            </div>
            <div class="export-item-scrollable-list">
              @for (item of availableExportItems | impureSearch:searchAvailableItem:['key']; track item.key;let index = $index;) {
              <p
                id="export-available-item-{{ index }}"
                class="mb-0 px-2 py-1 export-item export-item-hoverable c-pointer d-flex justify-content-between"
                (click)="onExportItemClick(exportItemType.available, item)"
              >
                <span>{{ item.label }}</span>
                <i class="ri-arrow-right-s-line move-item-arrow-icon"></i>
              </p>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <p class="font-weight-semibold">{{ "label-title.selected" | translate }}</p>
        <div class="export-left-column">
          <div class="search-box">
            <input
              type="text"
              id="export-selected-item-search"
              name="searchTerm"
              class="form-control"
              placeholder="{{ 'label-title.search' | translate }}"
              style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; border-color: var(--vz-border-color); border-bottom: 0"
              [(ngModel)]="searchSelectedItem"
            />
            <i class="ri-search-line search-icon"></i>
          </div>
          <div class="export-items-box border">
            <div id="export-selected-move-all" class="mb-0 px-2 py-1 c-pointer text-primary font-weight-semibold" (click)="onMoveAllClick(exportItemType.selected)">
              {{ "button-title.move-all" | translate }} <i class="ri-arrow-left-s-line"></i>
            </div>
            <div class="export-item-scrollable-list">
              @for (item of selectedExportItems | impureSearch:searchSelectedItem:['key']; track item.key;let index = $index;) {
              <p
                id="export-selected-item-{{ index }}"
                class="mb-0 px-2 py-1 export-item c-pointer d-flex justify-content-between"
                [ngClass]="{ 'export-item-hoverable': !item.mandatory }"
                (click)="onExportItemClick(exportItemType.selected, item)"
              >
                <span>
                  {{ item.label }}
                  @if (item.mandatory) {
                  <span class="text-danger">*</span>
                  }
                </span>
                <i class="ri-arrow-left-s-line move-item-arrow-icon" *ngIf="!item.mandatory"></i>
              </p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="offcanvas-footer d-flex justify-content-center gap-2 border-top">
    <button type="button" class="btn btn-soft-secondary" (click)="openExportHistoryModal()">{{ "button-ttile.export-history" | translate }}</button>
    <button type="button" class="btn btn-secondary" (click)="exportData()">{{ "button-title.export" | translate }}</button>
  </div>
</ng-template>

<app-export-history-modal #exportHistoryModal></app-export-history-modal>
